<!--
2022-09-26 Matt 代理
-->
<template>
  <div class="agentPage">
    <div class="navWrapper">
      <div class="nav">
        <div
          class="nav-item"
          :class="{'active':currentNavItem == 'portfolio'}"
          @click="chooseNavItem('portfolio')"
        >
          {{ $t('lang.agent.portfolio') }}
        </div>
        <div
          class="nav-item"
          :class="{'active':currentNavItem == 'rewards'}"
          @click="chooseNavItem('rewards')"
        >
          {{ $t('lang.agent.rewards') }}
        </div>
      </div>
    </div>

    <div class="portfolio" v-if="currentNavItem === 'portfolio'">
      <div class="qrCodeWrapper">
        <div class="qrCodeLabel">
          {{ $t('lang.agent.qrCode') }}
        </div>
        <div class="qrCode" ref="qrCode">
          <qrcode-vue
            :value="this.accountInfo.InviteLink"
            :size="140"
            background="#F6D9AA"
          >
          </qrcode-vue>
        </div>
        <div class="buttons">
          <button @click="downloadQrCode">
            {{ $t('lang.agent.download') }}
          </button>
          <button>
            {{ $t('lang.agent.share') }}
          </button>
        </div>
      </div>
      <div class="inviteWrapper">
        <div class="inviteLabel">
          {{ $t('lang.agent.inviteLink') }}
        </div>
        <div class="inviteLink">
          {{ this.accountInfo.InviteLink }}
        </div>
        <div class="buttons">
          <button @click="copyInviteLink">
            {{ $t('lang.agent.copy') }}
          </button>
          <button @click="showSharePopup()">
            {{ $t('lang.agent.share') }}
          </button>
        </div>
      </div>
      <div class="linksWrapper">
        <div class="links">
          <button @click="gotoRoute('rules')">
            {{ $t('lang.agent.rules') }}
          </button>
          <button @click="gotoRoute('agentWebsite')">
            {{ $t('lang.agent.agentSystem') }}
          </button>
        </div>
      </div>
    </div>

    <div class="rewards" v-if="currentNavItem === 'rewards'">
      <div class="balance">
        {{ $t('lang.agent.rewardBalance') }}
        <span class="rewardBalance">
          {{ fetchCurrency[userInfo.CurrencyName] }}
          {{ separateThousand(accountInfo.Cash) }}
        </span>
        <button @click="gotoRoute('/Withdraw')">
          {{ $t('lang.agent.withdraw') }}
        </button>
      </div>

      <div class="myRewards">
        <div class="label">
          {{ $t('lang.agent.myRewards') }}
        </div>
        <div class="details">
          <div class="rewardItem">
            <span class="label">
              {{ $t('lang.agent.totalRewards') }}
            </span>
            <span>
              {{ fetchCurrency[userInfo.CurrencyName] }}
              {{ separateThousand(myRewards.total) }}
            </span>
          </div>
          <div class="rewardItem">
            <span class="label">
              {{ $t('lang.agent.inviteRewards') }}
            </span>
            <span>
              {{ fetchCurrency[userInfo.CurrencyName] }}
              {{ separateThousand(myRewards.invite) }}
            </span>
          </div>
          <div class="rewardItem">
            <span class="label">
              {{ $t('lang.agent.depositRewards') }}
            </span>
            <span>
              {{ fetchCurrency[userInfo.CurrencyName] }}
              {{ separateThousand(myRewards.deposit) }}
            </span>
          </div>
          <div class="rewardItem">
            <span class="label">
              {{ $t('lang.agent.bettingRewards') }}
            </span>
            <span>
              {{ fetchCurrency[userInfo.CurrencyName] }}
              {{ separateThousand(myRewards.betting) }}
            </span>
          </div>
        </div>
        <div class="subordinates">
          <Loadmore
            :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
            :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
            :bottomLoadingText="$t('lang.loadingStatus.loading')"
            :auto-fill="false"
            :bottom-method="getMySubordinates"
            :bottom-all-loaded="hasLoadAll"
            ref="loadMoreSubordinates">
            <div class="row" v-for="(item, index) in mySubordinates" :key="index">
              <div class="first-row">
                <div class="name">
                  <span>{{ item.name }}</span>
                  <span class="level" v-if="item.level > 0">L{{ item.level }}</span>
                </div>
                <div class="createTime">
                  <span>{{ $t('lang.agent.createTime') }}</span>
                  <span class="value">{{ item.InviteTime }}</span>
                </div>
              </div>
              <div class="second-row">
                <div class="depositAmount">
                  <span class="title">
                    {{ $t('lang.agent.depositAmount') }}
                  </span>
                  <span>
                    {{ fetchCurrency[userInfo.CurrencyName] }}
                  </span>
                  <span>
                    {{ separateThousand(item.DepositAmount) }}
                  </span>
                </div>
              </div>
              <div class="third-row">
                <div class="bettingAmount">
                  <span class="title">
                    {{ $t('lang.agent.bettingAmount') }}
                  </span>
                  <span>
                    {{ fetchCurrency[userInfo.CurrencyName] }}
                  </span>
                  <span>
                    {{ separateThousand(item.BettingAmount) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="showMore" v-if="!hasLoadAll">
              <img :src="showMore" alt="showMore">
            </div>
            <div class="empty-tips" v-if="mySubordinates.length==0">
              <span>{{$t('lang.agent.emptyTips')}}</span>
            </div>
          </Loadmore>
          <div class="moreSubordinatesTips">
            {{ $t('lang.agent.moreSubordinatesTips') }}
            <span @click="gotoRoute('agentWebsite')">
              {{ $t('lang.agent.agentSystem') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <Popup v-model="popupVisible" position="bottom">
      <div class="socialMedias">
        <img :src="facebook" alt="Facebook" @click="openSocialMediaApp('facebook')">
        <img :src="telegram" alt="Telegram" @click="openSocialMediaApp('telegram')">
        <img :src="whatsapp" alt="Whatsapp" @click="openSocialMediaApp('whatsapp')">
      </div>
    </Popup>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { Loadmore, Toast, Popup } from 'mint-ui'

import whatsapp from '@/assets/images/common/whatsapp.svg'
import facebook from '@/assets/images/common/facebook.svg'
import telegram from '@/assets/images/common/telegram.svg'
import config from '../../../static/config/config'
import { separateThousand } from '@/utils'
import { fetchCurrency } from '@/constant'
import request from '@/service'
import showMore from '@/assets/images/common/showMore.gif'

export default {
  name: 'Agent',
  data () {
    return {
      config,
      whatsapp,
      facebook,
      telegram,
      showMore,
      separateThousand,
      fetchCurrency,
      facebookShareLink: '',
      telegramShareLink: '',
      whatsappShareLink: '',
      popupVisible: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      currentNavItem: 'portfolio',
      accountInfo: {},
      rewardBalance: 0,
      myRewards: {
        total: 0,
        invite: 0,
        deposit: 0,
        betting: 0
      },
      mySubordinates: [],
      hasLoadAll: false
    }
  },
  components: {
    QrcodeVue,
    Loadmore,
    Popup
  },
  watch: {},
  mounted () {
    this.fetchAccount()
    this.fetchAgentRewards()
    this.fetchSubordinates()
  },
  methods: {
    chooseNavItem: function (currentNavItem) {
      this.currentNavItem = currentNavItem
    },
    downloadQrCode: function () {
      const canvasImage = this.$refs.qrCode.getElementsByTagName('canvas')[0].toDataURL('image/png')
      const xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function () {
        const a = document.createElement('a')
        a.href = window.URL.createObjectURL(xhr.response)
        a.download = 'pge_agent_qrCode.png'
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }
      xhr.open('GET', canvasImage)
      xhr.send()
    },
    copyInviteLink: function () {
      navigator.clipboard
        .writeText(this.accountInfo.InviteLink)
        .then(Toast(this.$t('lang.agent.copySuccess')))
    },
    showSharePopup: function () {
      this.popupVisible = true
    },
    openSocialMediaApp (shareTo) {
      if (shareTo === 'facebook') {
        window.open(this.facebookShareLink, '_blank')
      } else if (shareTo === 'telegram') {
        window.open(this.telegramShareLink, '_blank')
      } else if (shareTo === 'whatsapp') {
        window.open(this.whatsappShareLink, '_blank')
      }
    },
    getMySubordinates () {
      const url = '/innovation/agent/getMySubordinates'
      const data = {
        userId: this.userInfo.UserId,
        lastId: this.mySubordinates.length > 0 ? this.mySubordinates[this.mySubordinates.length - 1].Id : 0
      }
      request('post', url, data).then(res => {
        if (res.Items.length > 0) {
          this.mySubordinates = this.mySubordinates.concat(res.Items)
        } else {
          this.hasLoadAll = true
        }
        this.$refs.loadMoreSubordinates.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      })
    },
    gotoRoute (path) {
      if (path === 'rules') {
        this.$router.push('/agent/rules')
      } else if (path === 'agentWebsite') {
        window.open(config.agentWebsite)
      } else {
        this.$router.push(path)
      }
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          this.accountInfo = res
          const welcomeMessage = this.$t('lang.agent.welcomeMessage')
          const message = welcomeMessage + encodeURIComponent(res.InviteLink)
          this.whatsappShareLink = `whatsapp://send?text=${message}`
          this.telegramShareLink = `https://t.me/share/url?url=${message}`
          this.facebookShareLink = `fb://faceweb/f?href=https://m.facebook.com/sharer.php?u=${this.accountInfo.InviteLink}`
        }).catch(err => {
          console.log(err)
        })
      }
    },
    fetchAgentRewards () {
      if (this.userInfo) {
        const url = `/innovation/agent/rewards?UserUniqueId=${this.userInfo.UserId}`
        request('get', url).then(res => {
          this.myRewards = {
            total: res.TotalReward,
            invite: res.TotalInviteReward,
            deposit: res.TotalDepositReward,
            betting: res.TotalBettingReward
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    fetchSubordinates () {
      if (this.userInfo) {
        const url = `/innovation/agent/my-subordinates?UserUniqueId=${this.userInfo.UserId}`
        request('get', url).then(res => {
          this.mySubordinates = res
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .agentPage {
    padding:56px 0 70px 0;
    background-color: rgba(0,0,0,.9);
    height: 98vh;
    overflow-y: hidden;

    .navWrapper {
      margin: 15px auto 20px;
      padding: 0 10px;
      border-bottom: 1px solid rgba(246, 217, 170, 0.5);
      height: 44px;
      width: 94vw;

      .nav {
        width: 100%;
        display: flex;

        .nav-item {
          flex: 1 0 40%;
          display: inline-block;
          margin: 4px 5px;
          padding: 2px 5px;
          min-width: 4em;
          line-height: 30px;
          text-align: center;
        }

        .active {
          background: #F6D9AA;
          color: #543200;
          border-radius: 6px;
        }
      }
    }

    .portfolio {
      margin: 10px auto;
      width: 94vw;

      .qrCodeWrapper {
        display: flex;
        height: 20vh;

        .qrCodeLabel {
          flex: 1 0 20%;
          text-align: center;
          line-height: 20vh;
          color: #F6D9AA;
        }

        .qrCode {
          flex: 1 0 50%;
          display: flex;
          justify-content: center;
          align-self: center;
        }

        .buttons {
          flex: 1 0 25%;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;

          button {
            background: #161616;
            color: #f2f8ff;
            height: 32px;
            font-size: 16px;
            font-weight: 400;
            border: 1px solid #161616;
            border-radius: 6px;

            &:hover {
              background: #f6d9aa;
              color: black;
              border: 1px solid #f6d9aa;
            }
          }
        }
      }

      .inviteWrapper {
        margin: 30px 8px 0;
        line-height: 32px;
        color: #F6D9AA;

        .inviteLink {
          width: 100%;
          text-align: center;
          color: #4E6297;
        }

        .buttons {
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          margin-top: 10px;

          button {
            background: #161616;
            color: #f2f8ff;
            height: 32px;
            width: 30vw;
            font-size: 16px;
            font-weight: 400;
            border: 1px solid #161616;
            border-radius: 6px;

            &:hover {
              background: #f6d9aa;
              color: black;
              border: 1px solid #f6d9aa;
            }
          }
        }
      }

      .linksWrapper {
        position: absolute;
        left: 0;
        bottom: 150px;
        width: 100%;

        .links {
          display: flex;
          flex-direction: row;
          justify-content: space-evenly;
          margin-top: 30px;

          button {
            background: rgba(0, 0, 0, .9);
            color: #f2f8ff;
            height: 32px;
            width: 30vw;
            font-size: 16px;
            font-weight: 400;
            border: none;
            border-bottom: 1px solid #f2f8ff;

            &:hover {
              color: #f6d9aa;
              border-bottom: 1px solid #f6d9aa;
            }
          }
        }
      }
    }

    .rewards {
      .balance {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        line-height: 33px;
        color: #F6D9AA;

        .rewardBalance {
          border: 1px solid #F6D9AA;
          border-radius: 6px;
          padding: 2px 10px;
          width: 130px;
        }

        button {
          background: #F6D9AA;
          color: black;
          height: 40px;
          width: 22vw;
          font-size: 16px;
          font-weight: 400;
          border: 1px solid #F6D9AA;
          border-radius: 6px;
        }
      }

      .myRewards {
        margin: 40px 20px 10px;
        color: #F6D9AA;

        .label {
          margin-bottom: 10px;
        }

        .details {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .rewardItem {
            width: 40vw;
            margin-bottom: 10px;
            color: #ffffff;

            span {
              display: block;
              text-align: right;
            }

            .label {
              color: rgba(246, 217, 170, 0.5)
            }
          }
        }
      }

      .subordinates {
        padding: 20px 0 0 0;
        height: 50vh;
        overflow-y: scroll;

        .row {
          margin: 0px 5px 20px 5px;
          padding: 15px 15px;
          background: #2F2F2F;
          border-radius: 6px;

          .first-row {
            display: flex;
            height: 40px;

            .name {
              flex: 1;
              overflow: hidden;
              font-size: 12px;
              color: #FFF;
              line-height: 35px;
              vertical-align: top;
            }

            .level {
              display: inline-block;
              margin-left: 10px;
              color: #F6D9AA;
            }

            .createTime {
              flex: 1;
              overflow: hidden;
              font-size: 10px;
              color: #FFF;
              text-align: right;
              line-height: 25px;
              padding-top: 10px;
              color: rgba(246, 217, 170, 0.5);

              .value {
                display: inline-block;
                margin-left: 10px;
                color: #ffffff;
              }
            }
          }

          .second-row {
            display: flex;
            color: #F6D9AA;
            line-height: 40px;

            .depositAmount {
              flex: 1;
              font-size: 18px;
              overflow: hidden;
              white-space: nowrap;

              .title {
                display: inline-block;
                font-size: 12px;
                color: rgba(246, 217, 170, 0.5);
              }
            }
          }

          .third-row {
            display: flex;
            color: #F6D9AA;
            line-height: 40px;

            .bettingAmount {
              flex: 1;
              font-size: 18px;
              text-align: left;

              .title {
                display: inline-block;
                font-size: 12px;
                color: rgba(246, 217, 170, 0.5);
              }
            }
          }
        }

        .showMore {
          text-align: center;
          img {
            width: 10px;
          }
        }

        .empty-tips {
          font-size: 14px;
          text-align: center;
          line-height: 25px;
          color: rgba(246, 217, 170, 0.5);
        }

        .moreSubordinatesTips {
          font-size: 12px;
          text-align: center;

          span {
            text-decoration: underline;
          }
        }
      }
    }

    .socialMedias {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100vw;
      height: 18vh;
      padding: 20px;
      background: #2F2F2F;

      img {
        width: 32px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Agent/index.vue